import { fetchJson } from '../../GlobalStateContainer'

import {
  UPDATING_SUMMARY_ASYNC,
  UPDATED_SUMMARY,
  PO_NUMBER_CHANGE
} from '../../GlobalStateContainer'

import { notifyError } from '../UserMessaging'

export const updatingSummaryAsync = () => ({ type: UPDATING_SUMMARY_ASYNC })

export const updatedSummary = (summary) => ({ type: UPDATED_SUMMARY, summary })


export const poNumberChange = (value) =>  ({type: PO_NUMBER_CHANGE, number: value})



const errorMessage = "An error occurred updating the shipping summary. Please refresh the page, or contact customer service.";
const updateSummaryAsyncFetchSpec = {
  endpoint : state => state.constants.navigation.cartSummaryEndpoint,
  fetchInit: { method: 'POST', credentials: 'same-origin' },
  notify   : () => updatingSummaryAsync(),
  extract  : response => response.json(),
  onSuccess: json => updatedSummary(json),
  onError  : diagnosticMessage => notifyError(errorMessage, diagnosticMessage)
}

export const updateSummary = fetchJson(updateSummaryAsyncFetchSpec)


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/Summary/summaryActions.js